// extracted by mini-css-extract-plugin
export default {"rotate":"Loader_rotate__6y7NQ","reverse":"Loader_reverse__fayNY"};